export default __webpack_public_path__ + "static/media/bacqueville10.3cfb162f.jpg";